module.exports = __webpack_public_path__ + "static/img/p4.41245bc3.png";